import React, { useState } from 'react';
import { contestInvoice } from './api';

/**
 * Contest an invoice with the supplier (backend/invoice_dispute.py): says what is wrong, and the server opens a claim
 * DRAFT for what was over-billed and holds the invoice. Nothing is sent to the supplier from here; the draft is reviewed
 * and sent from the Supplier claims screen.
 */
export default function ContestInvoice({ invoice, onChanged }) {
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const submit = async () => {
    setBusy(true); setError(null);
    try { await contestInvoice(invoice.id, reason.trim()); onChanged?.(); } catch (e) { setError(e.message); } finally { setBusy(false); }
  };

  if (!open) {
    return (
      <button type="button" onClick={() => setOpen(true)} data-testid="contest-invoice-open"
        className="min-h-[44px] px-4 rounded-xl border border-amber-600 text-amber-800 hover:bg-amber-100">
        Contest with the supplier
      </button>
    );
  }
  return (
    <div className="space-y-2" data-testid="contest-invoice">
      <label className="block text-sm text-gray-800" htmlFor="contest-reason">What is wrong with this invoice?</label>
      <textarea id="contest-reason" value={reason} onChange={(e) => setReason(e.target.value)} rows={2} maxLength={500}
        data-testid="contest-invoice-reason" className="w-full rounded-lg border border-gray-300 p-2 text-sm" />
      <div className="flex gap-2">
        <button type="button" disabled={busy || !reason.trim()} onClick={submit} data-testid="contest-invoice-submit"
          className="min-h-[44px] px-4 rounded-xl bg-amber-600 text-white disabled:opacity-50">
          Open a claim draft
        </button>
        <button type="button" onClick={() => setOpen(false)} className="min-h-[44px] px-4 rounded-xl text-gray-700">Cancel</button>
      </div>
      {error && <p className="text-sm text-red-700" data-testid="contest-invoice-error">{error}</p>}
    </div>
  );
}
